import { commonAPI } from "./commonApi";

const baseUrl=process.env.REACT_APP_BASEURL
const defaultHeaders = {
   "Content-Type": "application/json",
//    // "ngrok-skip-browser-warning": 69420
   "Authorization":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxLCJpc19hZG1pbiI6dHJ1ZSwidHlwZSI6ImFjY2VzcyIsImlzc3VlZF9hdCI6IjIwMjQtMDUtMDQgMTM6MjM6MzQiLCJleHAiOjE3MTQ4MzYyMTQuMH0.M6QacL_zY5pxaBEWepNsezdQ9qAXNSw1s8pnkZzDkFY"
};

// login API
// uses commonAPI function to send a POST request to the /api/user/login endpoint with user object as the request body.
export const loginAPI = async(user)=>{
    return await commonAPI("POST",`${baseUrl}/api/user/login`,user,"")
 }

//  opt checking
 export const verifyOtp = async(user)=>{
   return await commonAPI("POST",`${baseUrl}/api/user/verify-otp`,user,"")
}

//
 //logout api
 //uses commonAPI function to send a POST request to the /api/user/logout endpoint with user object as the request body and headerr object as the request header.
 export const logoutAPI = async(user,headerr)=>{
    return await commonAPI("POST",`${baseUrl}/api/user/logout`,user,headerr)
 }
//
//forgot password api
export const forgotPassword = async(user,headerr)=>{
   return await commonAPI("POST",`${baseUrl}/api/user/forgot-password`,user,headerr)
}

//  Add video api
export const AddVideoApi = async(videoDetails,headerr)=>{
    return await commonAPI("POST",`${baseUrl}/api/video_subtitle/video`,videoDetails,headerr)
 }
 
//  add kla
 export const AddKlApi = async(formData,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/KLA/`,formData,header)
}

//  add session
export const AddSessionApi = async(formData,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/session/`,formData,header)
}

//  add member
export const AddMemberApi = async(formData,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/Members/`,formData,header)
}

//  Governsers address
export const GetGAList=async(start,end)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/address-user?start=${start}&end=${end}`,"","")
}

//  Budget Speech
export const GetBSList=async(start,end)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/speech-user?start=${start}&end=${end}`,"","")
}
// Rulings
export const GetRList=async(start,end)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/Rulings-user?start=${start}&end=${end}`,"","")
}

// archuves
export const GetArchList=async()=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/video`,"","")
}

// archuves list
export const GetArchlistUser=async(start,end)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/video-user?start=${start}&end=${end}`,"","")
}

//  Get Latest Sessions
export const LatestSessions=async()=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/latest-session`,"","")
}

//  highlights
export const HighlisghtVideosApi=async()=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/latest-videos`,"","")
}

//  GetKlaForSearchFilter
export const GetKlaListForSearchFilter=async()=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/kla`,"","")
}

//  GetKlaList Admin
export const GetKlaListAdmin=async()=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/kla/list_kla`,"","")
}


export const GetSessionListForSearchFilter=async()=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/session-details/latest_session_latest_kla`,"","")
}

export const GetSessionListForSearchFilterWithKla=async(klaid)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/session-details/latest_session_by_kla/`,{kla:klaid},"")
}


//  GetEventForSearchFilter
export const GetEventListForSearchFilter=async()=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/event`,"","")
}

//  GetEvent list admin
export const GetEventListAdmin=async(start,end)=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/event/list_event?start=${start}&end=${end}`,"","")
}

//  GetMemberForSearchFilter if session not selected
export const GetMemberListForSearchFilter=async()=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/session-details/latest_session_members_filter`,"","")
}

//  Ggovenre list 
export const GetGovernerList=async()=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/session-details/governers_list`,"","")
}
//  GetMemberForSearchFilter if session not selected
export const GetMemberListForSearchFilterWithSession=async(sessionId)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/session-details/members_by_session/`,sessionId,"")
}

//  GetMemberForSearchFilter rulings if session  selected
export const GetMemberListForRulingsFilterWithSession=async(sessionId)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/session-details/speaker_list_by_session/`,sessionId,"")
}

//  GetMemberForSearchFilter rulings if session not selected
export const GetMemberListForRulingsFilter=async()=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/session-details/speaker_list/`,"","")
}

//  GetMemberForSearchFilter if session selected
export const GetMemberListForSearchFilterIfSession=async(session)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/session-details/members_by_session/`,session,"")
}

//  GetMemberForSearchFilter
export const GetConstituencyListForSearchFilter=async()=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/constituency`,"","")
}


//  GetMemberAdmin
export const GetConstituencyListAdmin=async(start,end)=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/constituency/list_constituency?start=${start}&end=${end}`,"","")
}

//  GEt inital date
export const GetInitialDate=async(sessionid)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/search/${sessionid}/get_session`,"","")
}

//   filter search
export const FilterSearch=async(searchData,start,end)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/search/filter_videos?start=${start}&end=${end}`,searchData,"")
}

//   previous , next
export const nextOrPrevVideos=async(videoIdNex)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/video/${videoIdNex}/next_video`,"","")
}

//   previous , next gov address
export const nextOrPrevVideosGov=async(videoIdNex)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/Governor-address/${videoIdNex}/next_video`,"","")
}

//   previous , next budget speech
export const nextOrPrevVideosBS=async(videoIdNex)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/Budget-speech/${videoIdNex}/next_video`,"","")
}

//   previous , next rulings
export const nextOrPrevVideosRS=async(videoIdNex)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/Rulings/${videoIdNex}/next_video`,"","")
}
 
//   views count update(video)
export const UpdateViewCount=async(videoId)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/video/${videoId}/views_count`,"","")
}

//   views count update(gov address)
export const UpdateViewCountGA=async(videoId)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/Governor-address/${videoId}/g_views_count`,"","")
}

//   views count update(budget speech)
export const UpdateViewCountBS=async(videoId)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/Budget-speech/${videoId}/b_views_count`,"","")
}

//   views count update(rulings)
export const UpdateViewCountRl=async(videoId)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/Rulings/${videoId}/r_views_count`,"","")
}

//   related members
export const relatesMembersVideo=async(videoId)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/video-user/member_video`,{video_id:videoId},"")
}

//   related members
export const relatesMembersGov=async(videoId)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/address-user/member_video`,{video_id:videoId},"")
}

//   related members
export const relatesMembersBS=async(videoId)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/speech-user/member_video`,{video_id:videoId},"")
}

//   related members
export const relatesMembersRL=async(videoId)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/Rulings-user/member_video`,{video_id:videoId},"")
}

//   related videos
export const relatesVideos=async(videoId)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/search-videos/${videoId}/related_videos`,"","")
}

//   related videos (gov addess)
export const relatesVideosGA=async(videoId)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/Governor-address/${videoId}/related_videos`,"","")
}

//   related videos (budget speech)
export const relatesVideosBS=async(videoId)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/Budget-speech/${videoId}/related_videos`,"","")
}

//   related videos (rulings)
export const relatesVideosRL=async(videoId)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/Rulings/${videoId}/related_videos`,"","")
}

//   search 
export const searchMain=async(searchQuery,start,end)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/search/?start=${start}&end=${end}`,searchQuery,"")
}

// filtering table data Archives page
export const FilterArchivesData=async(FilterQuery,start,end)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/filtersearch/filter_search?start=${start}&end=${end}`,FilterQuery,"")
}

// filtering table data search result page
export const FilterSearchResultData=async(FilterQuery,start,end)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/search/secondary_filter/?start=${start}&end=${end}`,FilterQuery,"")
}

// filtering table data governers page
export const FilterGovData=async(FilterQuery,start,end)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/filtersearch/gov_filter_search?start=${start}&end=${end}`,FilterQuery,"")
}

// filtering table data budgetspeech page
export const FilterBSData=async(FilterQuery,start,end)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/filtersearch/budgetspeech_filter_search?start=${start}&end=${end}`,FilterQuery,"")
}

// filtering table data rulings page
export const FilterRulingsData=async(FilterQuery,start,end)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/filtersearch/rulings_filter_search?start=${start}&end=${end}`,FilterQuery,"")
}


// get part videos
export const GetPartVideosGA=async(videoId)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/Governor-address/${videoId}`,"","")
}

// get part videos
export const GetPartVideosBS=async(videoId)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/Budget-speech/${videoId}`,"","")
}

// get part videos rulings
export const GetPartVideosRL=async(videoId)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/Rulings/${videoId}`,"","")
}

// get part videos rulings
export const GetPartVideos=async(videoId)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/view-video/${videoId}`,"","")
}

// getVideoList Admin
export const VideoListAdmin=async(header,start,end)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/video?start=${start}&end=${end}`,"",header)
}

// Add KLA Admin
export const AddKLA=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/kla/`,body,header)
}

// Add Member Admin
export const AddMembers=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/members/`,body,header)
}

// Add Member List
export const GetMemberList=async()=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/members`,"","")
}

//    members details-admin for table
export const MembersListApi=async()=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/member-mapping`,"","")
}

//    add member mapping details-admin
export const MemberMappinAdd=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/member-mapping/`,body,header)
}

// Add Constituency Admin
export const AddConstituency=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/constituency/`,body,header)
}

// Constituency List Admin
export const GetConstituency=async()=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/constituency`,"","")
}

// Constituency List Admin (mapped)
export const GetConstituencyMaped=async(id)=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/constituency/${id}/constituency_list`,"","")
}

// Add Role Admin
export const AddRole=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/member_role/`,body,header)
}

// Role List Admin
export const GetRole=async()=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/member_role`,"","")
}

// Role List Admin()
export const GetRoleAdmin=async()=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/member_role/list_role`,"","")
}

// Add Salutation Admin
export const AddSalutation=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/salutation/`,body,header)
}

// Salutation List Admin
export const GetSalutation=async()=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/salutation`,"","")
}

// Salutation List Admin with visibilit
export const GetSalutationAdminVisiblity=async()=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/salutation/list_salutation`,"","")
}

// Add Event Admin
export const AddEvtnt=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/event/`,body,header)
}

// Event List Admin
export const GetEvent=async()=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/event`,"","")
}
export const GetSittings=async()=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/calendar-sittings`,"","")
}

//delete Sittings
export const DeleteSittings=async(sittings_id,header)=>{
      return await commonAPI("DELETE",`${baseUrl}/api/profile/calendar-sittings/${sittings_id}`,"",header)
}

// Add Event Admin
export const SessionAddSdmin=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/session/`,body,header)
}

// Mebers mapping list for add kla Admin
export const GetMemberMappingList=async(Id)=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/member-mapping/${Id}/list_member`,"","")
}

// Mebers mapping list for table  Admin
export const getMemberListInTable=async(header,start,end)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/member-list?start=${start}&end=${end}`,"",header)
}

// Mebers  list for table  Admin(minimal details)
export const getMemberListLessDeatils=async(header)=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/members`,"",header)
}

// Mebers  list for table  Admin(minimal details) by condition for non mmebrs
export const getMemberListLessDeatilsByCondition=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/latest-session/list_members_profile/`,body??"",header)
}

// Mebers  list for table  Admin(minimal details) by condition for non mmebrs
export const getMemberListLessDeatilsByConditionNewSORTED=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/latest-session/list_members_with_constituency/`,body??"",header)
}
// Mebers  list for table  Admin(minimal details) by condition for non mmebrs
export const getMemberListLessDeatilsByConditionNewSORTEDWithKlaSessioNFIlter=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/latest-session/list_members_with_constituency_by_Session/`,body??"",header)
}

// Add calendar od sittings Admin
export const CalendarOfSittingsAdd=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/calendar-sittings/`,body,header)
}

// Home page progress bar Admin
export const HomeProgressBar=async(header)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/progress-bar/current_session_status`,"",header)
}

// chaange sequence number Admin
export const SeqNumberChange=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/video/update_videosequence`,body,header)
}

// Session List Table Admin
export const GetSessionListTable=async(header,start,end)=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/session?start=${start}&end=${end}`,"",header)
}

// Session List Table if kla selected Admin
export const GetSessionListTableWithKLA=async(body)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/session-details/latest_session_by_kla/`,body,"")
}

// chaange sequence number Admin
export const SeqNumberChangeGa=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/Governor-address/update_videosequence`,body,header)
}

// Governers addres List Table Admin
export const GovAddressListAdmin=async(header,start,end)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/Governor-address?start=${start}&end=${end}`,"",header)
}

// Members List video edit Table Admin
export const MembersList=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/member-list/get_member_by_session`,body,header)
}

// Add Governers address Admin
export const AddGovAddresApi=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/Governor-address`,body,header)
}

// Add Budget speech Admin
export const AddBudgetSpeechApi=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/Budget-speech`,body,header)
}

// chaange sequence number Budget Speech
export const SeqNumberChangeBs=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/Budget-speech/update_videosequence`,body,header)
}

//list 
export const BudgetSpeechListAdmin=async(header,start,end)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/Budget-speech?start=${start}&end=${end}`,"",header)
}

// Add Rulings Admin
export const AddRulingsApi=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/Rulings`,body,header)
}

// chaange sequence number Rlings
export const SeqNumberChangeRulings=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/Rulings/update_videosequence`,body,header)
}

// View Rulings Admin
export const ViewRulingsApi=async(header,start,end)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/Rulings?start=${start}&end=${end}`,"",header)
}

// Member mapping liost based on current Session
export const MemberMappingBySession=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/session/update_members_by_session/`,body,header)
}
// Sittings list based on current Session
export const SittingsListBasedOnSession=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/session/update_sitting_by_session/`,body,header)
}

// Highlighs list add by aDMIN
export const SetHighlightsVideioList=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/video-priority`,body,header)
}

// edit salutatiuon
export const EditSalutation=async(body,header)=>{
   return await commonAPI("PUT",`${baseUrl}/api/profile/salutation/${body.id}/`,body,header)
}

// edit role
export const EditRole=async(body,header)=>{
   return await commonAPI("PUT",`${baseUrl}/api/profile/member_role/${body.role_id}/`,body,header)
}

// edit constituency
export const EditConstituency=async(body,header)=>{
   return await commonAPI("PUT",`${baseUrl}/api/profile/constituency/${body.constituency_id}/`,body,header)
}

// edit event
export const EditEvent=async(body,header)=>{
   return await commonAPI("PUT",`${baseUrl}/api/profile/event/${body.event_id}/`,body,header)
}

// edit Sission
export const EditSession=async(body,header)=>{
   return await commonAPI("PUT",`${baseUrl}/api/profile/session/${body.session_id}/`,body,header)
}

// edit Kla
export const EditKla=async(body,header)=>{
   return await commonAPI("PUT",`${baseUrl}/api/profile/kla/${body.kla_id}/`,body,header)
}

// edit video
export const EditVideo=async(body,header)=>{
   return await commonAPI("PUT",`${baseUrl}/api/video_subtitle/video/${body.video_id}`,body,header)
}

// edit budget speech
export const EditBudgetSpeech=async(body,header)=>{
   return await commonAPI("PUT",`${baseUrl}/api/video_subtitle/Budget-speech/${body.video_id}`,body,header)
}

// edit governors address
export const EditGovAddress=async(body,header)=>{
   return await commonAPI("PUT",`${baseUrl}/api/video_subtitle/Governor-address/${body.video_id}`,body,header)
}

// edit Rulings
export const EditRulings=async(body,header)=>{
   return await commonAPI("PUT",`${baseUrl}/api/video_subtitle/Rulings/${body.video_id}`,body,header)
}

// edit MEMBER
export const EditMember=async(body,header,memberId)=>{
   return await commonAPI("PUT",`${baseUrl}/api/video_subtitle/member-list/${memberId}`,body,header)
}

// edit MEMBER List minimal details
export const EditMemberLessDetails=async(body,header,memberId)=>{
   return await commonAPI("PUT",`${baseUrl}/api/profile/members/${memberId}/`,body,header)
}

// edit MEMBER mapping details
export const EditMemberMemberMappingRow=async(body,header,memberId)=>{
   return await commonAPI("PUT",`${baseUrl}/api/profile/member-mapping/${memberId}/`,body,header)
}

// Member mapping edit Admin
export const MemberMappingEdit=async(body,header,sessionId)=>{
   return await commonAPI("PUT",`${baseUrl}/api/profile/member-mapping/${sessionId}/update_member_by_session/`,body,header)
}

// Edit sittings submit Admin
export const SubmitSittingsEdit=async(body,header,sessionId)=>{
   return await commonAPI("PUT",`${baseUrl}/api/profile/calendar-sittings/${sessionId}/update_sittings_by_session/`,body,header)
}

// video compres api--------------------------------------
// get compressions
export const getCompressed=async(viddoId)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/video-compressor?video_id=${viddoId}`,"","")
}

// post compressions
export const submitCompressed=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/video-compressor`,body,header)
}

// taglist api 
export const getVideoListForTag=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/videotag/videos_by_date`,body,header)
}

// taglist submit api 
export const PostTAg=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/videotag`,body,header)
}

// taglist submit api  gov
export const PostTAgGA=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/videotag`,body,header)
}

// taglist submit api  bs
export const PostTAgBS=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/videotag`,body,header)
}

// taglist submit api  rl
export const PostTAgRL=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/videotag`,body,header)
}

// timeline submit api 
export const PostTimeline=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/sub-titles`,body,header)
}
// tPublish video
export const publishVideos=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/video/publish_videos`,body,header)
}

// Hide KLA
export const hideKLA=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/kla/hide_kla/`,body,header)
}

// delete KLA
export const DeleteKla=async(klaid,header)=>{
   return await commonAPI("DELETE",`${baseUrl}/api/profile/kla/${klaid}`,"",header)
}

// Hide Video
export const hideVideo=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/video/hide_video`,body,header)
}

// delete video
export const DeleteVideo=async(videoid,header)=>{
   return await commonAPI("DELETE",`${baseUrl}/api/video_subtitle/video/${videoid}`,"",header)
}

// Hide Budget Speech
export const hideBudSpeech=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/Budget-speech/hide_speech`,body,header)
}

// delete Budget Speech
export const DeleteBudSpeech=async(videoid,header)=>{
   return await commonAPI("DELETE",`${baseUrl}/api/video_subtitle/Budget-speech/${videoid}`,"",header)
}

// Hide Gov Address
export const hideGovAddress=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/Governor-address/hide_address`,body,header)
}

// delete Gov Address
export const DeleteGovAddress=async(videoid,header)=>{
   return await commonAPI("DELETE",`${baseUrl}/api/video_subtitle/Governor-address/${videoid}`,"",header)
}

// Hide Rulings
export const hideRulings=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/Rulings/hide_rulings`,body,header)
}

// delete Rulings
export const DeleteRulings=async(videoid,header)=>{
   return await commonAPI("DELETE",`${baseUrl}/api/video_subtitle/Rulings/${videoid}`,"",header)
}

// Hide session
export const hideSession=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/session/hide_session/`,body,header)
}

// delete video
export const DeleteSession=async(sessionID,header)=>{
   return await commonAPI("DELETE",`${baseUrl}/api/profile/session/${sessionID}`,"",header)
}

// Hide event
export const hideEvent=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/event/hide_event/`,body,header)
}

// delete event
export const DeleteEvent=async(eventID,header)=>{
   return await commonAPI("DELETE",`${baseUrl}/api/profile/event/${eventID}`,"",header)
}

// Hide role
export const hideRole=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/member_role/hide_role/`,body,header)
}

// delete role
export const DeleteRole=async(roleID,header)=>{
   return await commonAPI("DELETE",`${baseUrl}/api/profile/member_role/${roleID}`,"",header)
}

// Hide role
export const hideConstituency=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/constituency/hide_constituency/`,body,header)
}

// delete role
export const DeleteConstituency=async(id,header)=>{
   return await commonAPI("DELETE",`${baseUrl}/api/profile/constituency/${id}`,"",header)
}

// Hide salutation
export const hideSalutation=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/salutation/hide_salutation/`,body,header)
}

// delete salutation
export const DeleteSalutation=async(id,header)=>{
   return await commonAPI("DELETE",`${baseUrl}/api/profile/salutation/${id}`,"",header)
}

//API for edit sittings
export const EditSittings=async(body,header)=>{
   return await commonAPI("PUT",`${baseUrl}/api/profile/calendar-sittings/${body.id}/`,body,header)
}
// delete MEmber
export const DeleteMember=async(id,header)=>{
   return await commonAPI("DELETE",`${baseUrl}/api/profile/members/${id}`,"",header)
}

// delete member mapping
export const DeleteMemberMapping=async(id,header)=>{
   return await commonAPI("DELETE",`${baseUrl}/api/profile/member-mapping/${id}`,"",header)
}

// filtering table data vide admin page
export const FiterVideoTableAdmin=async(FilterQuery,header,start,end)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/admin-filter/video_filter_search?start=${start}&end=${end}`,FilterQuery,header)

}

// filtering dashborad admin  page
export const FiterDashBoardAdmin=async(FilterQuery,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/progress-bar/filter_current_session_status`,FilterQuery,header)

}

// filtering dashborad admin  page
export const FiterMemberListAdmin=async(FilterQuery,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/latest-session/list_members_with_constituency_by_Session/`,FilterQuery,header)

}

// filtering table data sittings admin page
export const FiterSitingsTableAdmin=async(FilterQuery,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/calendar-sittings/get_calender_of_sittings/`,FilterQuery,header)

}

// filtering table data Gov address admin page
export const FiterGOVTableAdmin=async(FilterQuery,header,start,end)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/admin-filter/admin_gov_filter_search?start=${start}&end=${end}`,FilterQuery,header)

}

// filtering table data budget speech admin page
export const FiterBudgetSPTableAdmin=async(FilterQuery,header,start,end)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/admin-filter/admin_budgetspeech_filter_search?start=${start}&end=${end}`,FilterQuery,header)

}
// filtering table data rulings admin page
export const FiterRulingsTableAdmin=async(FilterQuery,header,start,end)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/admin-filter/admin_rulings_filter_search?start=${start}&end=${end}`,FilterQuery,header)

}

// filtering table data member mapping admin page
export const FiteMMTableAdmin=async(FilterQuery,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/member-mapping/filter_members/`,FilterQuery,header)

}

   // get TAGS with video id
   export const GEtTAgWithVideoID=async(videoId)=>{
      return await commonAPI("GET",`${baseUrl}/api/video_subtitle/videotag/${videoId}/list_tags`,"","")
   
   }

   
//  GetMemberForSearchFilter if session not selected
export const GetAllMemberIdArrayWithSession=async(sessionId)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/session-details/all_member_list_by_session/`,sessionId,"")
}

//  GetMemberForSearchFilter if session not selected
export const GetAllMemberIdArray=async()=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/session-details/all_member_list`,"","")
}


// filtering table data member mapping admin page
export const FilterSessionByKLATableAdmin=async(FilterQuery,header,start,end)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/session/filter_sessions/?start=${start}&end=${end}`,FilterQuery,header)

}

// update downloads count (user)
export const updateDownCount=async(Vid)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/video/${Vid}/download_count`,"","")
}

// update downloads count gov address (user)
export const updateDownCountGA=async(Vid)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/Governor-address/${Vid}/download_count`,"","")
}

// update downloads count budget speech (user)
export const updateDownCountBS=async(Vid)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/Budget-speech/${Vid}/download_count`,"","")
}

// update downloads count rulings(user)
export const updateDownCountRL=async(Vid)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/Rulings/${Vid}/download_count`,"","")
}

// get speaker image
export const initialSpeakerInfo=async()=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/home-speaker`,"","")
}

// update speaker image
export const UpdateSpeakerInfo=async(formData,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/home-speaker/`,formData,header)
}

// get tag list
export const GetTagListForEdit=async(vid,header)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/videotag/${vid}/list_tags`,"",header)
}

// get tag list Gov
export const GetTagListForEditGA=async(vid,header)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/videotag/${vid}/list_tags`,"",header)
}

// get tag list BS
export const GetTagListForEditBS=async(vid,header)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/videotag/${vid}/list_tags`,"",header)
}

// get tag list RL
export const GetTagListForEditRL=async(vid,header)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/videotag/${vid}/list_tags`,"",header)
}

// update PDF link
export const updatePdfLink=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/calendar-sittings/update_add_or_remove_pdf_link/`,body,header)
}

// get calendar od siitinghs
export const GetCalendarSittingsUser=async()=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/calendar-sittings/list_with_pdf`,"","")
}

// live button toggle admin
export const UpdateLive=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/status/live_status/`,body,header)
}

// live button get api
export const GetLiveButtonApi=async()=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/status/get_live_status/`,"","")
}


// getvideo by id
export const GetSpecificVideo=async(id)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/view-video/${id}`,"","")
}

//! Get SSOT List
export const GetSsotDetailsApi=async(header)=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/ssot`,"",header)
}

// Get admin lists
export const getAdminLists=async(header)=>{
   return await commonAPI("GET",`${baseUrl}/api/user/user`,"",header)
}

// map constituency
export const mapConstituency=async(body,header,id)=>{
   return await commonAPI("PUT",`${baseUrl}/api/profile/constituency/${id}/update_constituency_by_kla/`,body,header)
}

// constituency  list based on kla
export const constituencyMappedList=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/constituency/list_constituency_by_kla/`,body,header)
}

// Get Actitvity Log 
export const getActivityLog=async(header)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/logs/view_log`,"",header)
}

// post carousal image
export const CarousalImageAdd=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/home-image`,body,header)
}

// get carousal image
export const CarousalImageGet=async(header)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/home-image`,"",header)
}

// upload thumbnail
export const UploadThumbnail=async(body,header,Vid)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/video/${Vid}/update_thumbnail`,body,header)
}

// upload thumbnail govaddress
export const UploadThumbnailGA=async(body,header,Vid)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/Governor-address/${Vid}/update_thumbnail`,body,header)
}

// upload thumbnail budgetspeech
export const UploadThumbnailBS=async(body,header,Vid)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/Budget-speech/${Vid}/update_thumbnail`,body,header)
}
// upload thumbnail rulings
export const UploadThumbnailRL=async(body,header,Vid)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/Rulings/${Vid}/update_thumbnail`,body,header)
}

// search videos Admin
export const searchVideoAdmin=async(body,header,Vid)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/search/videoIdSearch`,body,header)
}

// change part order
export const updatePartOrder=async(body,header,Vid)=>{
   return await commonAPI("PUT",`${baseUrl}/api/video_subtitle/video/${Vid}/update_part_order`,body,header)
}

// change part order gov address
export const updatePartOrderGV=async(body,header,Vid)=>{
   return await commonAPI("PUT",`${baseUrl}/api/video_subtitle/Governor-address/${Vid}/update_part_order`,body,header)
}

// change part order budget speech
export const updatePartOrderBS=async(body,header,Vid)=>{
   return await commonAPI("PUT",`${baseUrl}/api/video_subtitle/Budget-speech/${Vid}/update_part_order`,body,header)
}

// change part order rulings
export const updatePartOrderRL=async(body,header,Vid)=>{
   return await commonAPI("PUT",`${baseUrl}/api/video_subtitle/Rulings/${Vid}/update_part_order`,body,header)
}

// get Youtube link initail
export const getInitialYTLink=async(header,Vid)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/video-link/${Vid}/list_link`,"",header)
}

// Post Youtube link initail
export const AddlYTLink=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/video_subtitle/video-link`,body,header)
}

// add role to admin
export const AddAdminRole=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/user/user-role`,body,header)
}

// get role
export const GetAdminRoleDropdown=async(header)=>{
   return await commonAPI("GET",`${baseUrl}/api/user/user-role/list_user_roles`,"",header)
}
// get role role Assigned List
export const roleAssignedList=async(userId,header)=>{
   return await commonAPI("GET",`${baseUrl}/api/user/user-role/${userId}`,"",header)
}

// get role role Assigned List
export const GetPriorityListInitial=async(header)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/video-priority`,"",header)
}

// constituency mapping list for table admin
export const COnstMappingTable=async(header)=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/constituency-mapping`,"",header)
}

// add reservation
export const AddReservation=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/reservation/`,body,header)
}

// get reservation
export const GetReservation=async(header)=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/reservation/`,"",header)
}

// edit reservation
export const EditReservation=async(body,header)=>{
   return await commonAPI("PUT",`${baseUrl}/api/profile/reservation/${body.id}/`,body,header)
}

// delete reservation
export const DeleteReservation=async(id,header)=>{
   return await commonAPI("DELETE",`${baseUrl}/api/profile/reservation/${id}/`,"",header)
}

// delete reservation
export const EditConstMapping=async(body,header)=>{
   return await commonAPI("PUT",`${baseUrl}/api/profile/constituency-mapping/${body.id}/`,body,header)
}

// delete reservation
export const AddNewAdminUser=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/user/register`,body,header)
}

// delete reservation
export const BlockOrUnbloackApi=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/user/user/block_user`,body,header)
}

// get sitting dates
export const getSittingDates=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/calendar-sittings/highlight_sittings/`,body,header)
}

// search member admin (member table)
export const SearchAMember=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/members/member_name_search/`,body,header)
}

//search consitituenc table
export const SearchConstituency=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/constituency/constituency_name_search/`,body,header)
}

//search consitituenc table
export const ImportDumbApi=async(body,header)=>{
   return await commonAPI("GET",`${baseUrl}/api/video_subtitle/database-dumb`,body,header)
}
//search consitituenc table
export const MemberHistory=async(memberId,header)=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/session-details/timeline_view?member_id=${memberId}`,"",header)
}
//add quick links
export const AddQuickLinks=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/quick-links/`,body,header)
}
//get quick links
export const GetQuickLinks=async()=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/quick-links/`,"","")
}
//add social media links
export const AddSocialMediaLinks=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/media-links/`,body,header)
}
//get quick links
export const GetSocialMediaLinks=async()=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/media-links/`,"","")
}
//get current speaker
export const getCurrentSpeaker=async(body)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/session-details/speaker_list_by_session/`,body,"")
}

//edit admin user
export const editAdminUser=async(body,header)=>{
   return await commonAPI("PUT",`${baseUrl}/api/user/user/${body?.id}`,body,header)
}

//add domain name
export const AddDomainName=async(body,header)=>{
   return await commonAPI("POST",`${baseUrl}/api/profile/domain-name/`,body,header)
}

//get domain name
export const getDomainName=async(header)=>{
   return await commonAPI("GET",`${baseUrl}/api/profile/domain-name/`,"",header)
}

//get domain name
export const DeleteDomain=async(id,header)=>{
   return await commonAPI("DELETE",`${baseUrl}/api/profile/domain-name/${id}/`,"",header)
}